

const inactiveLabel = (client)=>{
    return client.inactivate_account ? " (inactive)" : ""
}

//function that maps list of clients to form expected by react-select Select component
export const useMapClientsToOptions = clients =>
     clients.map(c => (
         { value: c.user_id_number,
           label: c.user_name,
            id:c.user_id_number  
        }))


